<template>
  <b-col>
    <b-card no-body class="p-2 border border-2">
      <div class="flex justify-between">
        <div class="flex gap-2">
          <b-img class="w-[20px] h-[20px]" src="https://storage.googleapis.com/komerce/assets/verified-icon.svg" />
          Broadcast
        </div>
        <FilterDropdown id="broadcast" :options="optionsFilter" :value="filterBroadcast"
          @change="handleFilterChange($event, 'broadcast')"
          @date-change="handleDateFilterChange($event, 'broadcast')" />
      </div>
      <div class="font-poppins text-[#626262] mb-2 font-semibold text-[28px] leading-[38px] tracking-[0] align-middle">
        Rp. {{ IDRWithoutLbl(animatedCard.broadcast.revenue || 0) }}
        <span
          class="rounded-lg px-[4px] font-poppins font-normal text-[12px] leading-[20px] tracking-[0] align-middle" :class="dataCard.broadcast.percentage.includes('-') ? 'bg-[#E31A1A] text-white' : 'text-[#34A770] bg-[#BEFCDE]'">{{
            dataCard.broadcast.percentage }}</span>
      </div>
      <div class="text-sm">
        Total Broadcast: <span class="font-bold text-[#626262]">{{ animatedCard.broadcast.total }}</span>
      </div>
    </b-card>
  </b-col>
</template>
<script>
import { IDRWithoutLbl } from '@/libs/currency'
import FilterDropdown from './FilterDropdown.vue'

export default {
  name: 'BroadcastCard',
  components: {
    FilterDropdown,
  },
  props: {
    animatedCard: {
      type: Object,
      required: true,
    },
    dataCard: {
      type: Object,
      required: true,
    },
    filterBroadcast: {
      type: String,
      default: 'All Time',
    },
    optionsFilter: {
      type: Array,
      default: () => ([
        { label: 'All Time', value: 'All Time' },
        { label: 'Last 7 Days', value: 'Last 7 Days' },
        { label: 'Last 30 Days', value: 'Last 30 Days' },
        { label: 'Date Picker', value: 'Date Picker' },
      ]),
    },
  },
  data() {
    return {
      IDRWithoutLbl,
    }
  },
  methods: {
    handleFilterChange(value, type) {
      this.$emit('change', { value, type })
    },
    handleDateFilterChange(dateRange, type) {
      this.$emit('date-change', { dateRange, type })
    },
  },
}
</script>
